import type { AppCopy } from '../catalogs';

export const slAppCopy = {
  welcomeHeading: 'Kako ti lahko danes pomagam?',
  thinking: 'Razmišljanje',
  scrollToBottom: 'Pomaknite se na dno',
  reasoning: 'Utemeljitev',
  reasoningInProgress: 'v teku',
  citationPages: 'Strani {first}–{last}',
  citationTitle: 'Odlomek vira',
  citationLoading: 'Nalaganje vira…',
  citationUnavailable: 'Navedeno besedilo ni na voljo ali nimate več dostopa.',
  citationOpen: 'Odpri vir',
  citationCopied: 'Navedba kopirana',
  copy: 'Kopiraj',
  more: 'več',
  tryAgain: 'poskusi ponovno',
  answerTruncated: 'Odgovor je dosegel omejitev dolžine in je bil odrezan.',
  continueAnswer: 'nadaljuj odgovor',
  exportMarkdown: 'Izvozi kot Markdown',
  edit: 'Uredi',
  cancel: 'Prekliči',
  update: 'posodobitev',
  previous: 'Prejšnja',
  next: 'Naprej',
  messagePlaceholder: 'Pošlji sporočilo ...',
  projectHomePlaceholder: 'Nov klepet: {project}',
  sharedChatEveryone: 'Vsi v podjetju {company} lahko berejo ta klepet',
  sharedChatOnePerson: 'Ta klepet lahko bere 1 oseba',
  sharedChatPeople: 'Število oseb, ki lahko berejo ta klepet: {count}',
  forkedChatPlaceholder: 'Nadaljujte s svojimi povezavami…',
  newAnswer: 'Nov odgovor',
  messageInput: 'Vnos sporočila',
  sendMessage: 'Pošlji sporočilo',
  stopGenerating: 'Nehajte ustvarjati',
  addAttachment: 'Dodajte prilogo',
  removeFile: 'Odstrani datoteko',
  attachmentPreview: 'Predogled priloge',
  imageAttachmentPreview: 'Predogled slikovne priloge',
  image: 'Slika',
  openLink: 'odpri povezavo',
  document: 'Dokument',
  file: 'Datoteka',
  attachment: 'priloga',
  uploadFailed: 'nalaganje ni uspelo',
  uploading: 'nalaganje',
  toolIncomplete: 'Nedokončano',
  toolActivity: 'Dejavnost',
  activityThinking: 'Razmišlja…',
  activityWriting: 'Piše…',
  activityWaiting: 'Čaka na vašo odobritev',
  activityStopped: 'Ustavljeno',
  activityCouldNotFinish: 'Ni bilo mogoče dokončati',
  activitySources: 'virov',
  activityShowThinking: 'Prikaži razmišljanje',
  activityOpen: 'Odpri dejavnost',
  activitySteps: 'Koraki',
  activitySourcesTab: 'Viri',
  activityUnavailable: 'Ta dejavnost ni na voljo.',
  activityInput: 'Vnos',
  activityOutput: 'Izhod',
  activityNoSources: 'Odgovor ne navaja virov.',
  activityApprovedByReply: 'Odobreno z vašim odgovorom',

  toolRunning: 'V teku',
  toolComplete: 'Končano',
  toolNeedsApproval: 'Potrebna je odobritev',
  toolInput: 'Vnos',
  toolCall: 'klic orodja',
  toolCalls: 'klice orodij',
  openMenu: 'Odpri meni',
  closeMenu: 'Zapri meni',
  close: 'Zapri',
  showInTextField: 'Prikaži v besedilnem polju',
  settings: 'Nastavitve',
  appearance: 'Videz',
  themeLight: 'Svetla',
  themeDark: 'Temna',
  themeSystem: 'Sistemska',
  themeChoiceHelp:
    'Velja na vseh vaših napravah. »Sistemska« sledi svetlemu ali temnemu načinu posamezne naprave.',
  themeSaveFailed: 'Videza ni bilo mogoče shraniti, zato je ostal nespremenjen. Poskusite znova.',
  toolUsed: 'Uporabljeno orodje',
  toolCancelled: 'Preklicano orodje',
  toolResult: 'rezultat:',
  toolError: 'Napaka:',
  toolCancelledReason: 'Razlog preklica:',
  approvalAllow: 'Dovoli',
  approvalAlwaysAllow: 'Vedno dovoli',
  approvalDeny: 'Zavrni',
  approvalAlwaysDeny: 'Vedno zavrni',
  approvalConfirm: 'Potrdi',
  approvalBack: 'Nazaj',
  approvalApprovedResult: 'Odobril uporabnik',
  approvalDeniedResult: 'Uporabnik je zavrnil izvedbo orodja',
  logout: 'Odjava',
  loginOrCreateAccount: 'Prijavite se / Ustvarite račun',
  newChat: 'Nov klepet',
  untitledChat: 'Klepet brez naslova',
  previousChats: 'Prejšnji klepeti',
  openChat: 'Odprite klepet {title}',
  moreActionsForChat: 'Več dejanj za {title}',
  chatActions: 'Dejanja klepeta',
  closeChatActions: 'Zapri dejanja klepeta',
  deleteChatQuestion: 'Želite izbrisati klepet?',
  deleteChatDescription: 'Klepet »{title}« bo trajno izbrisan.',
  deleteChat: 'Izbriši klepet',
  keepChat: 'Obdrži klepet',
  delete: 'Izbriši',
  deleting: 'Brisanje …',
  chatDeleteFailed: 'Klepeta ni bilo mogoče izbrisati. poskusi ponovno',
  settingsDescription: 'Prilagodite, kako pomočnik deluje za vas.',
  settingsDesktopDescription: 'Prilagodite, kako se pomočnik odziva na vas.',
  personalization: 'Personalizacija',
  personalizationDescription: 'Prilagodite navodila, ki jim pomočnik sledi pri vsakem odgovoru.',
  languageAndRegion: 'Jezik in regija',
  languageAndRegionDescription: 'Izberite jezik in časovni pas.',
  memories: 'Spomini',
  memoriesDescription: 'Oglejte si, uredite ali izbrišite, kar si pomočnik zapomni o vas.',
  account: 'Račun',
  accountDescription: 'Upravljanje računa in trajni izbris vaših podatkov.',
  backToSettings: 'Nazaj na nastavitve',
  closeSettings: 'Zapri nastavitve',
  settingsCategories: 'Kategorije nastavitev',
  yourSettings: 'Vaše nastavitve',
  dataAndAccount: 'Podatki in račun',
  viewAndManageMemories: 'Oglejte si in upravljajte, kaj si pomočnik zapomni',
  loginToUseMemories: 'Prijavite se za uporabo spominov',
  manageOrDeleteAccount: 'Upravljajte ali izbrišite račun',
  unsavedChanges: 'Imate neshranjene spremembe',
  unsavedCloseDescription: 'Če zaprete nastavitve, boste zavrgli spremembe na tej strani.',
  unsavedBackDescription: 'Če se vrnete nazaj, boste zavrgli spremembe na tej strani.',
  continueEditing: 'Nadaljujte z urejanjem',
  discardChanges: 'Zavrzi spremembe',
  saveChanges: 'Shranite spremembe',
  localSettingsNote: 'Shranjeno v tem brskalniku. Prijavite se, da shranite v svoj račun.',
  personality: 'Osebnost',
  personalityHelp: 'Navodila po meri, ki jih pomočnik upošteva pri vsakem odgovoru',
  personalityPlaceholder:
    'Na primer: Bodite jedrnati in konkretni. Živim v Göteborgu in obožujem vegetarijansko hrano.',
  timezone: 'Časovni pas',
  searchTimezone: 'Iskanje časovnih pasov ...',
  automaticBrowser: 'Samodejno (brskalnik)',
  saved: 'Shranjeno {date}',
  addMemory: 'Dodaj spomin',
  newMemory: 'Nov spomin',
  memoryPlaceholder: 'Na primer: Raje imam kratke, konkretne odgovore.',
  editMemory: 'Uredi spomin',
  saveMemory: 'Shrani spomin',
  deleteMemory: 'Izbriši spomin',
  memorySaveFailed: 'Pomnilnika ni bilo mogoče shraniti. poskusi ponovno',
  memoryLimitReached: 'Shraniš lahko največ 50 spominov. Izbriši enega, preden dodaš novega.',
  memoryInvalid: 'Spomini ne smejo vsebovati povezav. Odstrani povezavo in poskusi znova.',
  memoryDeleteFailed: 'Pomnilnika ni bilo mogoče izbrisati. poskusi ponovno',
  memoryLoadFailed: 'Spominov ni bilo mogoče naložiti.',
  loadingMemories: 'Nalaganje spominov …',
  emptyMemories:
    'Pomočnik shranjuje spomine o vas, medtem ko govorite – kaj vam je všeč, kje živite in kaj počnete. Tukaj si jih lahko ogledate, uredite in izbrišete.',
  deleteAccountHelp: 'Trajno izbrišite račun in vse povezane klepete, spomine in nastavitve.',
  deleteAccount: 'Izbriši račun',
  deleteAccountQuestion: 'Želite trajno izbrisati račun?',
  deleteAccountDescription:
    'Vsi klepeti, sporočila, spomini, nastavitve in poverilnice za prijavo bodo izbrisani. Tega dejanja ni mogoče razveljaviti.',
  deleteAccountConfirm: 'Da, izbriši moj račun',
  accountDeleteFailed:
    'Računa ni bilo mogoče izbrisati. Nič ni bilo odstranjeno - poskusite znova.',
  logoutEverywhereTitle: 'Vse naprave',
  logoutEverywhereHelp:
    'Odjavite se v vseh napravah in brskalnikih, kjer je vaš račun odprt, tudi v tej.',
  logoutEverywhere: 'Odjava povsod',
  logoutEverywhereQuestion: 'Se želite odjaviti v vseh napravah?',
  logoutEverywhereDescription:
    'V vseh napravah in brskalnikih, tudi v tej, se boste morali znova prijaviti. Vaši klepeti in nastavitve ostanejo nespremenjeni.',
  loggingOut: 'Odjavljanje…',
  logoutEverywhereFailed:
    'Nismo mogli potrditi, da ste bili odjavljeni povsod. Poskusite znova ali v drugi napravi preverite, ali ste še vedno prijavljeni.',
  settingsSaveFailed: 'Nastavitev ni bilo mogoče shraniti. poskusi ponovno',
  customInstructions: 'Navodila po meri',
  notSet: 'Ni nastavljeno',
  automaticLanguage: 'Samodejni jezik',
  automaticTimezone: 'samodejni časovni pas',
  appLanguage: 'Jezik aplikacije',
  appLanguageHelp:
    'Nadzoruje celoten vmesnik aplikacije in datume. Odgovori pomočnika še naprej sledijo jeziku, v katerem pišete.',
  automaticBrowserLanguage: 'Samodejno (jezik brskalnika)',
  previousLanguageChoice: 'Prejšnja izbira: {language} ({locale})',
  previousLanguageChoiceCode: 'Prejšnja izbira ({locale})',
  canvasCopyLink: 'Kopiraj povezavo',
  canvasLinkCopied: 'Povezava je kopirana',
  actionUpdatedWithEdits: 'Posodobljeno z vašimi spremembami',
  activityStepsDone:
    'one:korak končan|two:koraka končana|few:koraki končani|other:korakov končanih',
  activityResultsCount: 'one:rezultat|two:rezultata|few:rezultati|other:rezultatov',
  canvasCopyLinkFailed: 'Povezave ni bilo mogoče kopirati',
  canvasOpenInAgent: 'Odpri v aplikaciji {agent}',
  canvasExpand: 'Razširi',
  canvasExitFullView: 'Zapri celoten pogled',
  webSourceUnread:
    'Povezano v tem odgovoru. Poneva te strani ni prebrala, zato tu ni ničesar za prikaz.',
  webSourceOpenOriginal: 'Odpri izvirnik',
  toolProgressSettings: 'Spreminjanje vaših nastavitev…',
  toolProgressAgent: 'Ustvarjanje agenta…',
  toolProgressConnections: 'Iskanje možnosti povezave…',
  toolProgressResult: 'Pripravljanje rezultata…',
  toolProgressClarification: 'Pripravljanje pojasnila…',
  toolProgressKnowledge: 'Pripravljanje predlagane posodobitve znanja…',
  toolProgressQuestion: 'Pripravljanje vprašanja za vas…',
  toolProgressSkill: 'Oblikujemo vaš Skill…',
  toolErrorSettings: 'Vaše nastavitve niso bile spremenjene.',
  toolErrorAgent: 'Agenta ni bilo mogoče ustvariti.',
  toolErrorConnections: 'Možnosti povezave ni bilo mogoče naložiti.',
  toolErrorResult: 'Rezultat ni bil shranjen.',
  toolErrorClarification: 'Pojasnila ni bilo mogoče pripraviti.',
  toolErrorKnowledge: 'Predlagane posodobitve znanja ni bilo mogoče pripraviti.',
  toolErrorQuestion: 'Vprašanja ni bilo mogoče pripraviti.',
  toolErrorSkill: 'Osnutka Skilla ni bilo mogoče shraniti.',
  toolErrorOpenSettings: 'Odpri Nastavitve',
  toolErrorOpenAgents: 'Odpri Agente',
  toolErrorOpenConnections: 'Odpri Povezave',
  toolStepIncomplete: 'Ta korak ni bil dokončan.',
  toolEarlierAttemptsFailed:
    'one:prejšnji poskus ni uspel|two:prejšnja poskusa nista uspela|few:prejšnji poskusi niso uspeli|other:prejšnjih poskusov ni uspelo',
} satisfies AppCopy;
